import React, { memo } from 'react';

import { PhoneArrowDownLeftIcon, PhoneArrowUpRightIcon } from '@ergeon/icons/hero/micro';
import { Call } from '@twilio/voice-sdk';

import { CallDirectionIconProps } from './types';

const iconClasses = 'size-5 shrink-0 text-blue-500 dark:text-blue-600';
const animatedIconClasses = 'top-0 left-0 absolute size-5 text-blue-500 dark:text-blue-600 animate-ping shrink-0';

const CallDirectionIcon: React.FC<CallDirectionIconProps> = memo(({ direction, isActive }) => {
  const Icon = direction === Call.CallDirection.Incoming ? PhoneArrowDownLeftIcon : PhoneArrowUpRightIcon;
  const testId = direction === Call.CallDirection.Incoming ? 'incoming-call-icon' : 'outgoing-call-icon';

  return (
    <div className="relative shrink-0">
      <Icon className={iconClasses} data-testid={testId} />
      {isActive && <Icon className={animatedIconClasses} data-testid={testId} />}
    </div>
  );
});

CallDirectionIcon.displayName = 'CallDirectionIcon';

export default CallDirectionIcon;
